var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardNumberFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12533 13.4167H4.79199C4.45033 13.4167 4.16699 13.1333 4.16699 12.7917C4.16699 12.45 4.45033 12.1667 4.79199 12.1667H8.12533C8.46699 12.1667 8.75033 12.45 8.75033 12.7917C8.75033 13.1333 8.46699 13.4167 8.12533 13.4167Z",
    fill: "#0ABAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1253 13.4167H9.79199C9.45033 13.4167 9.16699 13.1333 9.16699 12.7917C9.16699 12.45 9.45033 12.1667 9.79199 12.1667H13.1253C13.467 12.1667 13.7503 12.45 13.7503 12.7917C13.7503 13.1333 13.467 13.4167 13.1253 13.4167Z",
    fill: "#0ABAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9587 13V8C18.9587 4.325 17.842 3.20833 14.167 3.20833H5.83366C2.15866 3.20833 1.04199 4.325 1.04199 8L1.04199 13C1.04199 16.675 2.15866 17.7917 5.83366 17.7917H14.167C17.842 17.7917 18.9587 16.675 18.9587 13ZM5.83366 16.5417C2.85866 16.5417 2.29199 15.9833 2.29199 13L2.29199 9.00016L17.7087 9.00016V13C17.7087 15.9833 17.142 16.5417 14.167 16.5417H5.83366ZM17.7025 7.50016C17.634 4.95315 16.9677 4.45833 14.167 4.45833H5.83366C3.03298 4.45833 2.36667 4.95315 2.2982 7.50016L17.7025 7.50016Z",
    fill: "#0ABAB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNumberFilled);
export default __webpack_public_path__ + "static/media/card_number_filled.0cb9e7fe188e282966883e2a79bd38b4.svg";
export { ForwardRef as ReactComponent };